/* =====================================================================
   CUSTOM CHANGE START – youmee-card.js
   Youmee.market · Produktkarte: Warenkorb-Button + Quick-Add
   Neue Datei (kein Original) · Stand 2026-10-17

   - Ohne Varianten: Klick legt direkt in den Warenkorb (Shopify /cart/add.js)
   - Mit Varianten:  Desktop → Panel über dem Bild, Mobile (≤ 800px) → Bottom-Sheet
   - Danach: Warenkorb-Zähler im Header aktualisieren + kurze Bestätigung
   - Läuft per Event-Delegation, funktioniert auch nach Neuladen im Theme-Editor
   ===================================================================== */
(function () {
  'use strict';
  if (window.__ymCardReady) return;
  window.__ymCardReady = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mqMobile = window.matchMedia('(max-width: 800px)');
  var open = null; /* { panel, backdrop, card, trigger } */
  var toastEl = null;
  var toastTimer = null;

  /* ---------- Bestätigung ---------- */
  function toast(message, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ym-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var text = document.createElement('span');
    text.textContent = message;
    toastEl.appendChild(text);
    if (withLink) {
      var a = document.createElement('a');
      a.href = ROOT + 'cart';
      a.textContent = 'Zum Warenkorb';
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- Warenkorb ---------- */
  function addToCart(variantId) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Fehler');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  function refreshCartCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sel = '[data-cart-count], .cart-count, .cartCount, .cart-count-bubble span, [data-cart-count-bubble], .js-cart-count';
        document.querySelectorAll(sel).forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = false;
          el.style.removeProperty('display');
        });
        document.dispatchEvent(new CustomEvent('ym:cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cart }));
        return cart;
      })
      .catch(function () {});
  }

  function markAdded(card) {
    var btn = card && card.querySelector('.ym-card__cart');
    if (!btn) return;
    btn.classList.add('is-added');
    if (card.dataset.unique === 'true') {
      btn.dataset.done = '1';
      btn.setAttribute('aria-label', 'Liegt im Warenkorb');
    } else {
      setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
    }
  }

  function doAdd(variantId, loadingEl, card) {
    loadingEl.classList.add('is-loading');
    loadingEl.setAttribute('aria-busy', 'true');
    return addToCart(variantId)
      .then(function () {
        closeQA(false);
        markAdded(card);
        toast('Im Warenkorb', true);
        return refreshCartCount();
      })
      .catch(function (err) {
        if (err.status === 422) {
          toast('Dieses Teil liegt schon in deinem Warenkorb.', true);
        } else {
          toast('Hat leider nicht geklappt. Versuch es nochmals.', false);
        }
      })
      .then(function () {
        loadingEl.classList.remove('is-loading');
        loadingEl.removeAttribute('aria-busy');
      });
  }

  /* ---------- Quick-Add ---------- */
  function openQA(card, trigger) {
    closeQA(false);
    var tpl = card.querySelector('template.ym-qa-tpl');
    if (!tpl) return;
    var panel = tpl.content.firstElementChild.cloneNode(true);
    var backdrop = null;

    if (mqMobile.matches) {
      backdrop = document.createElement('div');
      backdrop.className = 'ym-qa-backdrop';
      panel.classList.add('is-sheet');
      panel.setAttribute('aria-modal', 'true');
      backdrop.appendChild(panel);
      document.body.appendChild(backdrop);
      document.documentElement.classList.add('ym-qa-lock');
      enableSwipe(panel);
    } else {
      card.querySelector('.ym-card__media').appendChild(panel);
    }

    card.classList.add('is-qa-open');
    trigger.setAttribute('aria-expanded', 'true');
    open = { panel: panel, backdrop: backdrop, card: card, trigger: trigger };

    /* Nur eine Variante verfügbar → gleich vorwählen */
    var enabled = panel.querySelectorAll('.ym-chip:not(:disabled)');
    if (enabled.length === 1) selectChip(enabled[0]);

    var focusTarget = panel.querySelector('.ym-chip[aria-checked="true"]') || enabled[0] || panel.querySelector('[data-qa-add]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closeQA(returnFocus) {
    if (!open) return;
    var o = open;
    open = null;
    if (o.backdrop) {
      o.backdrop.remove();
      document.documentElement.classList.remove('ym-qa-lock');
    } else {
      o.panel.remove();
    }
    o.card.classList.remove('is-qa-open');
    o.trigger.setAttribute('aria-expanded', 'false');
    if (returnFocus !== false && o.trigger.isConnected) o.trigger.focus({ preventScroll: true });
  }

  function selectChip(chip) {
    var panel = chip.closest('.ym-qa');
    panel.querySelectorAll('.ym-chip').forEach(function (c) {
      c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
    });
    var label = panel.querySelector('[data-qa-selected]');
    if (label) label.textContent = chip.firstChild ? chip.firstChild.textContent.trim() : chip.textContent.trim();
    var price = panel.querySelector('.ym-qa__price');
    if (price && chip.dataset.price) price.textContent = chip.dataset.price;
    var hint = panel.querySelector('[data-qa-hint]');
    if (hint) hint.hidden = true;
  }

  function enableSwipe(panel) {
    var startY = null;
    panel.addEventListener('touchstart', function (e) {
      startY = panel.scrollTop <= 0 ? e.touches[0].clientY : null;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      var dy = e.touches[0].clientY - startY;
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function (e) {
      if (startY === null) return;
      var dy = e.changedTouches[0].clientY - startY;
      startY = null;
      if (dy > 90) { closeQA(); } else { panel.style.transform = ''; }
    });
  }

  /* ---------- Klicks ---------- */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-ym-cart]');
    if (cartBtn) {
      e.preventDefault();
      var card = cartBtn.closest('.ym-card');
      if (cartBtn.dataset.done) { toast('Liegt schon in deinem Warenkorb.', true); return; }
      if (open && open.card === card) { closeQA(); return; }
      if (cartBtn.dataset.variantId) {
        doAdd(cartBtn.dataset.variantId, cartBtn, card);
      } else {
        openQA(card, cartBtn);
      }
      return;
    }

    if (!open) return;

    var chip = e.target.closest('.ym-chip');
    if (chip && open.panel.contains(chip)) {
      if (!chip.disabled) selectChip(chip);
      return;
    }

    var addBtn = e.target.closest('[data-qa-add]');
    if (addBtn && open.panel.contains(addBtn)) {
      var selected = open.panel.querySelector('.ym-chip[aria-checked="true"]');
      if (!selected) {
        var hint = open.panel.querySelector('[data-qa-hint]');
        if (hint) hint.hidden = false;
        var first = open.panel.querySelector('.ym-chip:not(:disabled)');
        if (first) first.focus();
        return;
      }
      doAdd(selected.dataset.variantId, addBtn, open.card);
      return;
    }

    if (e.target.closest('[data-qa-close]')) { closeQA(); return; }

    /* Klick ausserhalb (oder auf den dunklen Hintergrund) schliesst */
    if (!open.panel.contains(e.target)) closeQA(false);
  });

  /* Tastatur: Esc schliesst, Pfeiltasten wechseln die Chips */
  document.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') { closeQA(); return; }
    if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && e.target.classList.contains('ym-chip')) {
      var chips = Array.prototype.slice.call(open.panel.querySelectorAll('.ym-chip:not(:disabled)'));
      var i = chips.indexOf(e.target);
      if (i < 0) return;
      e.preventDefault();
      var next = chips[(i + (e.key === 'ArrowRight' ? 1 : -1) + chips.length) % chips.length];
      selectChip(next);
      next.focus();
    }
  });

  /* Wechsel Desktop ↔ Mobile während das Panel offen ist */
  var onMq = function () { closeQA(false); };
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', onMq);
  else if (mqMobile.addListener) mqMobile.addListener(onMq);

  /* Theme-Editor: Section neu geladen → offenes Panel schliessen */
  document.addEventListener('shopify:section:unload', function () { closeQA(false); });
})();
/* CUSTOM CHANGE END – youmee-card.js */
